
import './App.css';
import KrpanoExample from './Pages/krpano';

function App() {
  return (
    <>
    <KrpanoExample/>
    </>
  );
}

export default App;
